import { BadgeCheck, Wrench, Timer } from "lucide-react";

const ITEMS = [
  {
    icon: BadgeCheck,
    title: "Certified Engineers",
    copy: "Experienced fire safety engineers delivering professional workmanship.",
  },
  {
    icon: Wrench,
    title: "Installation, Maintenance & Testing",
    copy: "Complete lifecycle support — from new installations to routine servicing.",
  },
  {
    icon: Timer,
    title: "Fast Response Times",
    copy: "Prompt, responsive support across Ireland when you need us.",
  },
];

export default function TrustStrip() {
  return (
    <section
      className="bg-slate-50 border-y border-slate-200"
      data-testid="trust-strip"
      aria-label="Why choose Fire Safety Systems"
    >
      <div className="fss-container py-10 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {ITEMS.map((it, i) => (
            <div
              key={i}
              className="flex items-start gap-4"
              data-testid={`trust-item-${i}`}
            >
              <div className="w-11 h-11 border border-slate-200 bg-white flex items-center justify-center shrink-0 rounded-sm">
                <it.icon className="w-5 h-5 text-green-700" strokeWidth={1.75} />
              </div>
              <div>
                <div className="font-display font-semibold text-slate-900">
                  {it.title}
                </div>
                <p className="mt-1 text-sm text-slate-600 leading-relaxed">
                  {it.copy}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
